import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Switch } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { PATH } from '../../router/PATH';

export const NotFound: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('pages');
    const copy = React.useMemo(
        () => ({
            title: t('notFound.title'),
            subtitle: t('notFound.subtitle'),
            action: t('notFound.action'),
        }),
        [t],
    );

    return (
        <div
            className="flex h-lvh w-full flex-col items-center justify-center gap-2"
            {...getNodeTestIdProp('not-found-page')}
        >
            <h1>{copy.title}</h1>
            <h2>{copy.subtitle}</h2>
            {/* `onPress`, not `onClick`: HeroUI buttons are react-aria
                pressables, which fire on keyboard and touch as well as mouse.
                `onClick` reaches the DOM node underneath and misses those. */}
            <div className="flex flex-col gap-4">
                <Switch>
                    <Switch.Content>
                        <Switch.Control>
                            <Switch.Thumb />
                        </Switch.Control>
                        Label after
                    </Switch.Content>
                </Switch>
                <Switch>
                    <Switch.Content>
                        Label before
                        <Switch.Control>
                            <Switch.Thumb />
                        </Switch.Control>
                    </Switch.Content>
                </Switch>
            </div>
            <Button onPress={() => navigate(PATH.HOME)} size="lg">
                {copy.action}
            </Button>
        </div>
    );
};
